import { render, staticRenderFns } from "./roomInfo.vue?vue&type=template&id=07121f74&scoped=true"
import script from "./roomInfo.vue?vue&type=script&lang=js"
export * from "./roomInfo.vue?vue&type=script&lang=js"
import style0 from "./roomInfo.vue?vue&type=style&index=0&id=07121f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07121f74",
  null
  
)

export default component.exports